import styled from "styled-components";

export const StyledDirectionTableContainer = styled.div`
	& button {
		margin-top: 5rem;
	}
`;

export const StyledDirectionTableSearch = styled.div`
	margin-bottom: 1rem;
	display: flex;
	align-items: center;
	justify-content: flex-start;

	& form {
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}
`;

export const StyledDirectionTableHeader = styled.div`
	margin-bottom: 1rem;
	padding: 1.1rem 2rem;

	background-color: #dde5ef;
	border-bottom: 1px solid #4d6382;

	display: flex;
	align-items: center;
	justify-content: space-between;
	column-gap: 2rem;

	& > span {
		width: 10%;

		color: #283239;
		font-size: 1.2rem;
		font-weight: 500;

		display: block;
	}

	& > span:nth-child(2) {
		width: 42%;
	}

	& > span:nth-child(3) {
		width: 12%;
	}

	& > span:nth-child(4) {
		width: 29%;
	}

	& > span:nth-child(5) {
		width: 7%;
	}

	${(props) => {
		let res = "";
		if (props.sizes) {
			props.sizes.map((e, i) => {
				res += `& > span:nth-child(${i + 1}) { width: ${e}%; } `;
			});
		}
		return res;
	}}
`;

export const StyledDirectionTable = styled.div`
	margin: 0.4rem 0;
	padding: 0.6rem 1.8rem;

	display: flex;
	align-items: center;
	justify-content: space-between;
	column-gap: 2rem;

	background-color: #ffffff;

	& img {
		cursor: pointer;
	}

	& span {
		font-size: 1.4rem;
		font-weight: 300;
		white-space: nowrap;
		text-overflow: ellipsis;

		padding-right: 1rem;

		display: flex;
		column-gap: 0.5rem;

		& > button {
			margin-top: 0;
		}
	}

	& .text-button {
		& span {
			max-width: 80%;
			overflow: hidden;
			text-transform: ellapsis;
		}
	}

	& > span {
		width: 10%;
		overflow: hidden;

		&:nth-child(2) {
			width: 42%;
		}

		&:nth-child(3) {
			width: 12%;
		}

		&:nth-child(4) {
			width: 29%;
		}
	}

	${(props) => {
		let res = "";
		if (props.sizes) {
			props.sizes.map((e, i) => {
				res += `& > span:nth-child(${i + 1}) { width: ${e}%; } `;
			});
		}
		return res;
	}}

	& input {
		width: 80rem;
		margin-bottom: 0;
	}

	& div {
		width: 7%;

		display: flex;
		align-items: center;

		& img {
			height: 1.6rem;
			margin-right: 1.6rem;

			cursor: pointer;
		}
	}
`;
